//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';

import AddCircleIcon from '@material-ui/icons/AddCircle';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, withStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
}));
const styles = theme => ({
    previewBody: {
        background: '#FFFFFF',
        border: '1px dashed #D5D7DD',
        borderRadius: '10px',
        width: '270px',
        height: '180px',
        textAlign: 'center',
    },
    previewBodyBg: {
        background: '#F0F2F6',
        border: '1px dashed #D5D7DD',
        borderRadius: '6px',
        width: '254px',
        height: '68px',
        margin: 'auto',
        marginTop: '8px',
    },
    previewProfilePic: {
        background: '#F1F8F8',
        border: '1px dashed #1D8A8B',
        borderRadius: '8px',
        width: '68px',
        height: '68px',
        margin: 'auto',
        textAlign: 'center',
    },
    previewImg: {
        borderRadius: '8px',
        width: '68px',
        height: '68px',
    },
    dpBody: {
        marginTop: '-44px',
    },
    plusIconOutlined: {
        marginTop: '22px',
        color: '#1D8A8B',
    },
    skeltonLine: {
        width: '124px',
        height: '6px',
        borderRadius: '8px',
        background: '#F0F2F6',
        margin: 'auto',
        marginTop: '10px',
    },
    skeltonOval: {
        width: '40px',
        height: '16px',
        borderRadius: '8px',
        background: '#F0F2F6',
        display: 'inline-block',
        marginTop: '8px',
        marginRight: '2px',
        marginLeft: '2px',
    },
});

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { props } = params;
    const { classes } = props;

    const defns = {};

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const BrandingLogoPreview = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { logoUrl } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.previewBody}>
                <div {...defns.previewBodyBg}></div>
                <div {...defns.dpBody}>
                    {!logoUrl ? (
                        <div {...defns.previewProfilePic}>
                            <AddCircleIcon {...defns.plusIconOutlined} />
                        </div>
                    ) : (
                        <div>
                            <img {...defns.previewImg} alt="" src={logoUrl} />
                        </div>
                    )}

                    <div {...defns.skeltonLine}></div>
                    <div {...defns.skeltonOval}></div>
                    <div {...defns.skeltonOval}></div>
                </div>
            </div>
        </div>
    );
};

export default withStyles(styles)(BrandingLogoPreview);
